<template>
  <div>
    <a-card :loading="loading" title="趋势分析" :bordered="false">
      <div slot="extra">
        <a-range-picker
          :ranges="{
            今天: [moment(), moment()],
            最近七天: [moment().subtract('days', 6), moment()],
            本月: [moment().startOf('month'), moment()]
          }"
          :placeholder="['开始日期', '结束日期']"
          @change="handleChangeDate"
        />
      </div>
      <ul class="ant-page-data-list" v-if="chartData && chartData.sum">
        <li>
          <span>浏览量(PV)</span>
          {{ chartData.sum[0] }}
        </li>
        <li>
          <span>访客数(UV)</span>
          {{ chartData.sum[1] }}
        </li>
        <li>
          <span>IP数</span>
          {{ chartData.sum[2] }}
        </li>
        <li>
          <span>跳出率</span>
          {{ chartData.sum[3] }}%
        </li>
        <li>
          <span>平均访问时长</span>
          {{ chartData.sum[4] | formatSeconds }}
        </li>
      </ul>
      <ve-line
        :extend="extend"
        :data="chartData"
        :mark-point="markPoint"
        :mark-line="markLine"
        :legend-visible="true"
        :data-empty="dataEmpty"
        :settings="chartSettings"
        :toolbox="toolbox"
      >
      </ve-line>
    </a-card>
  </div>
</template>

<script>
import { requestGet } from '@/api/api'
import VeLine from 'v-charts/lib/line.common'

import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/markLine'
import 'v-charts/lib/style.css'

export default {
    name: 'BaiduCharts',
    components: {
        [VeLine.name]: VeLine
    },
    data () {
        this.markLine = {
            data: [
                {
                    name: '平均线',
                    type: 'average'
                }
            ]
        }
        this.markPoint = {
            data: [
                {
                    name: '最大值',
                    type: 'max'
                },
                {
                    name: '最小值',
                    type: 'min'
                }
            ]
        }
        this.toolbox = {
            feature: {
                saveAsImage: {}
            }
        }
        this.extend = {
            'yAxis.1.axisLabel': {
                formatter: '{value} %'
            },
            series: {
                label: {
                    normal: {
                        show: false
                    }
                }
            }
        }
        this.chartSettings = {
            axisSite: { right: ['跳出率'] },
            yAxisType: ['KMB', 'normal'],
            yAxisName: ['数值', '跳出率']
        }
        return {
            chartData: {
                columns: [],
                rows: []
            },
            params: {},
            loading: false,
            dataEmpty: true
        }
    },
    mounted () {
        this.getAnalysisTrend()
    },
    methods: {
        /**
         * 获取图表数据
         * @jdy
         * @2020-12-16
         */
        getAnalysisTrend (params) {
            this.loading = !this.loading
            requestGet('/analysis/trend', params)
                .then(res => {
                    this.dataEmpty = false
                    this.chartData = res.result
                })
                .catch(err => {
                    this.$notification.error(err)
                })
                .finally(() => {
                    this.loading = !this.loading
                })
        },
        /**
         * 筛选：日期筛选
         * params:{
         *  created_at_start
         *  created_at_end
         * }
         *
         * @params
         * @jdy
         * @2020-12-16
         */
        handleChangeDate (values) {
            if (values.length !== 0) {
                const start = this.moment(values[0]).format('YYYY-MM-DD') // 日期格式转换
                const end = this.moment(values[1]).format('YYYY-MM-DD') // 日期格式转换
                this.params.start_date = start
                this.params.end_date = end
            } else {
                delete this.params.start_date // 清空日期删除键
                delete this.params.end_date
            }
            this.getAnalysisTrend(this.params)
        }
    }
}
</script>

<style lang="less" scoped>
.ant-page-data-list {
    display: flex;
    margin-bottom: 1rem;
    justify-content: space-between;
    @media (max-width: 768px) {
        flex-direction: column;
    }
    li {
        flex: 1 1 auto;
        font-weight: bold;
        font-size: 1.5rem;
        position: relative;
        @media (min-width: 768px) {
            &:not(:last-child) {
                &::after {
                    content: '';
                    position: absolute;
                    height: 100%;
                    width: 1px;
                    background-color: rgba(0, 0, 0, 0.05);
                    right: 25px;
                    top: 0;
                }
            }
        }
        span {
            display: block;
            font-size: 0.875rem;
            color: #888;
            font-weight: normal;
        }
    }
}
</style>
